import { render, staticRenderFns } from "./DecisionAiCoachList.vue?vue&type=template&id=495a6d97&scoped=true"
import script from "./DecisionAiCoachList.vue?vue&type=script&lang=js"
export * from "./DecisionAiCoachList.vue?vue&type=script&lang=js"
import style0 from "./DecisionAiCoachList.vue?vue&type=style&index=0&id=495a6d97&prod&lang=scss&scoped=true"
import style1 from "./DecisionAiCoachList.vue?vue&type=style&index=1&id=495a6d97&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495a6d97",
  null
  
)

export default component.exports